import { configFile } from "@/config";
import { BreadcrumbType } from "@/Types/types";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex } from "@chakra-ui/react";
import Link from "next/link";

type Props = {
  data: BreadcrumbType[]
}

export default function Breadcrumbs({ data }: Props) {

  return (
    <Flex
      marginTop="80px"
      mb='32px'
      height='32px'
      position={'relative'}
      alignItems="center"
      _before={{
        content: '""', position: 'absolute', bottom: '0', top: '0', right: '-1', w: '50px', background: 'linear-gradient(270deg, #F7FAFC 0%, rgba(255, 255, 255, 0) 84.88%)'
      }}
      overflow='hidden'
    >
      <Breadcrumb
        color='gray.500'
        fontWeight={'normal'}
        fontSize='sm'
        lineHeight='5'
        separator={<ChevronRightIcon color='gray.500' />}
        overflow='scroll'
        __css={{
          '& ol': {
            display: 'block',
            width: 'max-content'
          },
          msOverFlowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        {data?.length ?
          data.map(
            (breadcrumb, index) => (
              <BreadcrumbItem color={index === data.length - 1 ? configFile.primaryAccentColor : ""} key={index} pr={index === data.length - 1 ? "40px" : "0"}>
                <BreadcrumbLink wordBreak={'normal'} as={Link} href={breadcrumb.href}>{breadcrumb.label}</BreadcrumbLink>
              </BreadcrumbItem>
            )
          ) : <></>
        }
      </Breadcrumb>
    </Flex >
  )
}